import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EDUCATION_TYPES, GENDER_TYPES, PROFESSION_TYPES } from 'src/app/core/models/enum.model';
import { RegisterModel } from 'src/app/core/models/register.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoadingService } from 'src/app/core/services/loading.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  model = new RegisterModel();
  registerForm: FormGroup;
  genderTypes = GENDER_TYPES;
  educationTypes = EDUCATION_TYPES;
  professionTypes = PROFESSION_TYPES;
  securityNumber1: number = 0;
  securityNumber2: number = 0;
  resultSecurity: number = 0;
  securityIsValid: boolean = false;
  cities = [];
  universities = [];
  volunteerCategories = [];

  isWorking = false;
  isUniversity = false;
  isSchoolName = false;
  isDepartmant = false;

  constructor(private authService: AuthService,
    private formBuilder: FormBuilder,
    private loadingService: LoadingService,
    private alertService: AlertService,
    private router: Router) { }

  ngOnInit(): void {
    this.registerForm = this.formBuilder.group({
      fullName: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(100)
      ]),
      gender: new FormControl(null, [
        Validators.required
      ]),
      birthDate: new FormControl('', [
        Validators.required
      ]),
      email: new FormControl('', Validators.compose([Validators.required,
        Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        ])),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20)
      ]),
      phone: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10)
      ]),
      primaryCityId: new FormControl(null, [
        Validators.required
      ]),
      educationLevel: new FormControl(null, [
        Validators.required
      ]),
      universityId: new FormControl(null),
      isOtherUniversity: new FormControl(''),
      schoolName: new FormControl(''),
      departmant: new FormControl(''),
      professionType: new FormControl(null, [
        Validators.required
      ]),
      company: new FormControl(''),
      position: new FormControl(''),
      isKvkk: new FormControl('', [
        Validators.requiredTrue
      ]),
      isAlumni: new FormControl(false),
      isTermsAndUsage: new FormControl('', [
        Validators.requiredTrue
      ]),
      isElectronicMessage: new FormControl('', [
        Validators.requiredTrue
      ]),
      selectedCategories: new FormControl('')
    });
    this.model.isAlumni = false;
    this.getCities();
    this.getUniversities();
    this.getVolunteerCategories();
  }


  async getCities() {
    const data: any = await this.authService.getUserToken().toPromise();
    this.authService.getCitySelectList(data.token).subscribe(response => {
      if (response.success) {
        this.cities = response.cities;
      }
    });
  }

  async getUniversities() {
    const data: any = await this.authService.getUserToken().toPromise();
    this.authService.getUniversitySelectList(data.token).subscribe(response => {
      if (response.success) {
        this.universities = response.universities;
      }
    });
  }

  async getVolunteerCategories() {
    const data: any = await this.authService.getUserToken().toPromise();
    this.authService.getVolunteerCategories(data.token).subscribe(response => {
      if (response.success) {
        this.volunteerCategories = response.volunteerCategories;
        console.log(this.volunteerCategories);
      }
    });
  }

  workingStatus(){
    if (this.model.professionType === 1 || this.model.professionType === 4 || this.model.professionType === 5){
      this.isWorking = true;
    } else {
      this.isWorking = false;
    }
  }

  educationLevel(){
    if (this.model.educationLevel === 1 || this.model.educationLevel === 2 || this.model.educationLevel === 7){
      this.isSchoolName = true;
      this.isUniversity = false;
      this.isDepartmant = false;
    } else {
      this.isSchoolName = false;
      this.isUniversity = true;
      this.isDepartmant = true;
    }
  }

  otherUniversity(){
    if (this.model.isOtherUniversity){
      this.isSchoolName = true;
    } else {
      this.isSchoolName = false;
    }
  }

  async register(){
    if (this.registerForm.invalid) {
      this.alertService.alert('Hata', 'Lütfen formdaki alanları eksiksiz tamamlayınız!', 'error')
      console.log("invalid!")
      return;
    }
    if (this.registerForm.valid) {
      this.loadingService.setLoading(true);
      let data = Object.assign({}, this.registerForm.value);
      
      this.model.fullName = data.fullName;
      this.model.gender = data.gender;
      this.model.birthDate = data.birthDate;
      this.model.phone = data.phone;
      this.model.email = data.email;
      this.model.primaryCityId = data.primaryCityId;
      this.model.schoolName = data.schoolName;
      this.model.universityId = data.universityId;
      this.model.departmant = data.departmant;
      this.model.educationLevel = data.educationLevel;
      this.model.professionType = data.professionType;
      this.model.company = data.company;
      this.model.position = data.position;
      this.model.password = data.password;
      this.model.isKvkk = data.isKvkk;
      this.model.isOtherUniversity = data.isOtherUniversity;
      this.model.isAlumni = data.isAlumni;
      this.model.selectedCategories = data.selectedCategories;

      const dataObj: any = await this.authService.getUserToken().toPromise();
      this.loadingService.setLoading(true);
      this.authService.registerUser(this.model, dataObj.token).subscribe(response => {
        if (response.success) {
          this.alertService.alert('Başarılı!', 'Kullanıcınız oluşturuldu, giriş yapabilirsiniz!', 'success');
          this.loadingService.setLoading(false);
          this.router.navigate(['/']);
        }
      }, (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      })
    }
  }

  get f() {
    return this.registerForm.controls;
  }
}
